import React, { useState } from 'react'

import Modal from 'react-bootstrap/Modal'

const Number2TextConverter = (props) => {
    const [params, setParams] = useState(props.field && props.field.dataset && props.field.dataset.params ? JSON.parse(decodeURIComponent(escape(atob(props.field.dataset.params)))) : undefined)

    const show = props.field && props.field.dataset.datatype === "number"

    //TODO: Find a way to share those with the server
    const currencyUSD2 = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        useGrouping: true,
        maximumFractionDigits: 2,
    }); 

    const currencyUSD0 = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        useGrouping: true,
        maximumFractionDigits: 0,
    }); 

    return <Modal show={show} onHide={() => props.onHide()} className="alert">
        <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <input type="radio" name="format" id="format1" value="currencyUSD2" checked={params && params.format === "currencyUSD2"} onClick={(e) => { setParams({ format: e.target.value }) }} />
            &nbsp;<label for="format1">{currencyUSD2.format(12345.678)}</label> <br /> 
            <input type="radio" name="format2" id="format2" value="currencyUSD0" checked={params && params.format === "currencyUSD0"} onClick={(e) => { setParams({ format: e.target.value }) }} />
            &nbsp;<label for="format2">{currencyUSD0.format(12345.678)}</label> <br />
            
        </Modal.Body>
        <Modal.Footer>
            <button type="button" className="submit-btn" data-dismiss="modal" onClick={() => { props.onParamsUpdated(params); props.onHide(); }}>{props.buttonText}</button>
        </Modal.Footer>
    </Modal>
}

export default Number2TextConverter